import {SVGProps, useId} from 'react';

import {COLORS} from '@/styles/colors';

export const IdCardIcon = (props: SVGProps<SVGSVGElement>) => {
  const maskId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24px'}
      height={props.height ?? '24px'}
      fill="none"
      viewBox="0 0 24 24"
      {...props}>
      <mask
        id={maskId}
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}>
        <path
          fill={COLORS.BACKGROUND_ON_SECONDARY_CONTAINER}
          d="M0 0h24v24H0z"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          fill={props.color ?? COLORS.ON_SURFACE_1}
          d="M17.88 13.251c.297 0 .546-.1.747-.301.201-.201.301-.45.301-.747 0-.296-.1-.545-.3-.746-.202-.201-.45-.301-.747-.301H15.12c-.297 0-.546.1-.747.3-.2.202-.301.45-.301.747s.1.546.301.747c.201.2.45.301.747.301h2.76Zm0-3.095c.297 0 .546-.1.747-.302.201-.2.301-.45.301-.746 0-.297-.1-.546-.3-.747-.202-.2-.45-.301-.747-.301H15.12c-.297 0-.546.1-.747.301-.2.201-.301.45-.301.747s.1.546.301.746c.201.201.45.302.747.302h2.76ZM9.073 13.06c-.592 0-1.131.054-1.618.162-.486.109-.913.28-1.282.513-.334.205-.585.429-.752.672a1.36 1.36 0 0 0-.251.786c0 .213.082.391.245.534a.884.884 0 0 0 .601.213h6.113c.234 0 .431-.075.593-.227a.743.743 0 0 0 .242-.565c0-.251-.083-.495-.25-.732-.168-.237-.415-.464-.741-.681a4.007 4.007 0 0 0-1.283-.513 7.443 7.443 0 0 0-1.617-.162Zm0-1c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.021-.588-1.413a1.926 1.926 0 0 0-1.412-.587c-.55 0-1.021.196-1.413.587a1.926 1.926 0 0 0-.587 1.413c0 .55.196 1.02.587 1.412.392.392.863.588 1.413.588Zm-5 8.143c-.63 0-1.166-.221-1.61-.665a2.193 2.193 0 0 1-.665-1.61V6.072c0-.63.222-1.166.665-1.61.444-.443.98-.665 1.61-.665h15.856c.63 0 1.167.222 1.61.665.444.444.665.98.665 1.61v11.856c0 .63-.221 1.167-.665 1.61-.443.444-.98.665-1.61.665H4.072Zm0-2.275h15.856V6.072H4.072v11.856Z"
        />
      </g>
    </svg>
  );
};
